import { render, staticRenderFns } from "./logininvite.vue?vue&type=template&id=bc72a2ca&"
import script from "./logininvite.vue?vue&type=script&lang=js&"
export * from "./logininvite.vue?vue&type=script&lang=js&"
import style0 from "./logininvite.vue?vue&type=style&index=0&id=bc72a2ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports